import { ReactNode } from "react";
import { Route, Routes, Link, useLocation } from "react-router-dom";
import { MantineProvider, createStyles, Button } from "@mantine/core";
import { makeVsethTheme, VSETHThemeProvider, VSETHInternalApp} from "vseth-canine-ui";
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import protoFiles from "../providedFiles.json"
import { Overview } from "../pages/overview";
import { Readme } from "../pages/readme";

/**
 * `App` is the main component of the application it set up the main structural components
 * such as the navigation bar and the Routes.
 */

 const useStyles = createStyles((_theme, _params, _getRef) => ({
	container: {
		marginTop: 20,
		marginBottom: 20,
		width: "100%",
		display: "flex",
		alignItems: "center",
		flexDirection: "column",
		minHeight: "64vh",
	},
	content: {
		maxWidth: 970,
		width: "100%",
	},
	checkbox: { margin: 10 },
}));


const routeEntry = (file: any) => {
    return <Route
                path={file.name}
                element={
                    <>
                    <Button component="a" href="/">Back to Overview</Button>
                    <SwaggerUI url={file.path}/>
                    </>
                }
            />; 
}

function App(){
    
    const { classes } = useStyles();

    const navList = [{href: "/", label: "Overview", icon: ""}, {href: "/readme", label: "Readme", icon: ""}]

    const routeBlock = [];
    for (let file of protoFiles.nav) {
        routeBlock.push(routeEntry(file));
    }

	const theme = makeVsethTheme();

    return (
        <>
			<MantineProvider theme={theme}>
				<VSETHThemeProvider theme={theme}>
                    <VSETHInternalApp
                        title="VSETH GRPC Restful Doc"
                        nav={navList}
                        makeWrapper={(url: string | undefined, child: ReactNode) => (
                            <Link to={url!} style={{ textDecoration: "none", color: "inherit" }}>
                                {child}
                            </Link>
                        )}
                        activeHref={useLocation().pathname}
                    >
                        <div className={classes.container}>
                            <div className={classes.content}>
                                <Routes>
                                    <Route path="/" element={<Overview/>}/> 
                                    <Route path="/readme" element={<Readme/>}/> 
                                    {routeBlock}
                                </Routes>
                            </div>
                        </div>
                    </VSETHInternalApp>
				</VSETHThemeProvider>
			</MantineProvider>
		</>
    );
};

export default App;
